﻿import { useMemo, useState } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { Card, Calendar, Tag, Alert, Spin } from "antd";
import "./Styles.css";

export default function AllPatientsCalendarCard({
  sessions = [],
  isLoading = false,
  embedded = false,
}) {
  const [selectedDate, setSelectedDate] = useState(dayjs());

  const safeSessions = useMemo(
    () => (Array.isArray(sessions) ? sessions : []),
    [sessions]
  );

  const sessionsByDate = useMemo(() => {
    // Index des sessions par jour pour alimenter le calendrier
    const map = new Map();
    safeSessions.forEach((session) => {
      if (!session?.date) return;
      const key = dayjs(session.date).format("YYYY-MM-DD");
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(session);
    });
    return map;
  }, [safeSessions]);

  const selectedDateSessions = useMemo(() => {
    // Sessions du jour clique
    const key = selectedDate.format("YYYY-MM-DD");
    return sessionsByDate.get(key) || [];
  }, [selectedDate, sessionsByDate]);

  const dateCellRender = (value) => {
    const key = value.format("YYYY-MM-DD");
    const count = (sessionsByDate.get(key) || []).length;
    if (!count) return null;

    return (
      <ul className="events">
        <li>
          <Tag color="blue">{count > 1 ? `${count} sessions` : "1 session"}</Tag>
        </li>
      </ul>
    );
  };

  const calendarContent = isLoading ? (
    <div style={{ padding: 20, textAlign: "center" }}>
      <Spin />
    </div>
  ) : (
    <>
      <div className="session-calendar-container">
        <Calendar
          fullscreen={false}
          value={selectedDate}
          onSelect={setSelectedDate}
          cellRender={dateCellRender}
        />
      </div>

      <div style={{ marginTop: 12 }}>
        {selectedDateSessions.length ? (
          <Alert
            type="info"
            showIcon
            message={`${selectedDateSessions.length} session(s) le ${selectedDate.format("DD/MM/YYYY")}`}
          />
        ) : (
          <Alert
            type="info"
            showIcon
            message={`Aucune session le ${selectedDate.format("DD/MM/YYYY")}`}
          />
        )}
      </div>
    </>
  );

  if (embedded) {
    return calendarContent;
  }

  return (
    <div>
      <h2 className="section-header">Calendrier des sessions</h2>
      <Card>{calendarContent}</Card>
    </div>
  );
}

AllPatientsCalendarCard.propTypes = {
  sessions: PropTypes.array,
  isLoading: PropTypes.bool,
  embedded: PropTypes.bool,
};



